import { useMutation } from "@tanstack/react-query";
import { triggerNotification } from "components/TheComponents/Notification";
import { useAppContext } from "contexts";
import { ExceptionHandlingType } from "types/apiServiceTypes";
import { getErrorMessageFromResponse } from "helpers/apiHelpers";

export function useDeleteSiteRewardMutation({ onHandleSuccess }: { onHandleSuccess?: () => void }) {
  const { apiService } = useAppContext();

  return useMutation({
    mutationFn: async ({ otp, id }: { otp: string; id: string }) => {
      const response = await apiService.form(
        `/site-rewards/${id}`,
        new FormData(),
        ExceptionHandlingType.MANUAL,
        { method: "DELETE", headers: { "x-otp": otp } }
      );
      return response;
    },
    onSuccess: () => {
      triggerNotification({ text: "Site Reward Deleted!", type: "success" });
      onHandleSuccess?.();
    },
    onError: (error) => {
      triggerNotification({ type: "error", text: getErrorMessageFromResponse(error) });
    },
  });
}
